export const isPrerendered = () => {
  // !!! If you want to prerender - change result to true !!!
  return false
}

export const firePrerenderEvent = () => document.dispatchEvent(new Event('render-event'))
